import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private apiURL: string = '';
  private apiCode: string = '';

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironmentNew().url;
    this.apiCode = this.appConfig.getEnvironmentNew().key;
  }

  SendTimings(partnerID, eventID, eventArea, event, metaData) {
    let dateTime = new Date();

    let body = {
      PartnerID: partnerID,
      EventID: eventID,
      EventSystem: 'PORTAL',
      EventArea: eventArea,
      Event: event,
      StartTime: dateTime.toISOString(),
      EndTime: dateTime.toISOString(),
      StartTimeUTC: dateTime.toISOString(),
      EndTimeUTC: dateTime.toISOString(),
      OS: 'Browser',
      MetaData: metaData,
    };

    let requestOptions =
      this.helpersService.getAuthenticatedRequestOptionsNew();
    try {
      return this.http
        .post(
          this.apiURL + '/v4.0/Analytics/Timings?code=' + this.apiCode,
          body,
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            console.log(res);
            return throwError(res);
          }),
        );
    } catch (Error: any) {
      console.log(Error?.message);
    }
  }
}
